// ContactSection.jsx
import React, { useState } from "react";
import useContactForm from "../../../hooks/useContactForm";
import "./contactSection.css";

const ContactSection = () => {
  const { form, loading, error, handleChange, handleSubmit } = useContactForm();
  const [fieldErrors, setFieldErrors] = useState({});
  const [flashMessage, setFlashMessage] = useState(null);

  const displayFlashMessage = (msg) => {
    setFlashMessage(msg);
    setTimeout(() => {
      setFlashMessage(null);
    }, 3000);
  };

  const onSubmit = async (e) => {
    const result = await handleSubmit(e);
    if (result.success) {
      setFieldErrors({});
      displayFlashMessage("Mensaje enviado con éxito");
    } else {
      // Translate backend validation errors to ES and map to fields
      const translateError = (param, msg) => {
        const normalized = (msg || '').toLowerCase();
        if (param === 'email' || normalized.includes('email')) return 'Ingresa un correo válido';
        if (param === 'phone' || normalized.includes('phone')) return 'Ingresa un teléfono válido';
        if (param === 'subject' || normalized.includes('subject')) return 'El asunto debe tener entre 5 y 200 caracteres';
        if (param === 'message' || normalized.includes('message')) return 'El mensaje debe tener entre 10 y 5000 caracteres';
        if (param === 'name' || normalized.includes('name')) return 'Ingresa un nombre válido';
        if (normalized.includes('required')) return 'Este campo es obligatorio';
        return 'Valor inválido';
      };

      // Map backend validation errors to a field -> message map
      if (Array.isArray(result?.details)) {
        const mapped = {};
        result.details.forEach((d) => {
          const key = d.param || d.field;
          const msg = translateError(key, d.msg || d.message);
          if (key) mapped[key] = msg;
        });
        setFieldErrors(mapped);
      }
      // Flash a generic ES error summary
      displayFlashMessage('Revisa los campos marcados en rojo');
    }
  };

  const onFieldChange = (e) => {
    const { name } = e.target;
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: undefined }));
    }
    handleChange(e);
  };

  return (
    <section className="contact">
      <div className="contact__inner">
        <form className="contact__form" onSubmit={onSubmit}>
          <div className="contact__header">
            <h2 className="contact__title">Resolvemos Tus Dudas</h2>
          </div>
          {/* NAME GROUP */}
          <div className="contact__group">
            <div className="contact__row contact__row--name">
              <label className="contact__label">Nombre completo</label>
              {/* desktop inputs */}
              <div className="contact__field">
                <input
                  className={`contact__input name-first ${fieldErrors.firstName ? 'contact__input--error' : ''}`}
                  placeholder="Nombre"
                  name="firstName"
                  value={form.firstName}
                  onChange={onFieldChange}
                />
                {fieldErrors.firstName && (
                  <p className="contact__error">{fieldErrors.firstName}</p>
                )}
              </div>
              <div className="contact__field">
                <input
                  className={`contact__input name-last ${fieldErrors.lastName ? 'contact__input--error' : ''}`}
                  placeholder="Apellido"
                  name="lastName"
                  value={form.lastName}
                  onChange={onFieldChange}
                />
                {fieldErrors.lastName && (
                  <p className="contact__error">{fieldErrors.lastName}</p>
                )}
              </div>
              {/* mobile-only full-name input, no placeholder */}
              <div className="contact__field">
                <input
                  className={`contact__input full-name ${fieldErrors.name ? 'contact__input--error' : ''}`}
                  name="name"
                  value={form.name}
                  onChange={onFieldChange}
                  placeholder=""
                />
                {fieldErrors.name && (
                  <p className="contact__error">{fieldErrors.name}</p>
                )}
              </div>
            </div>
          </div>

          {/* EMAIL */}
          <div className="contact__group">
            <div className="contact__row">
              <label className="contact__label">Correo electrónico</label>
              <div className="contact__field">
                <input
                  className={`contact__input ${fieldErrors.email ? 'contact__input--error' : ''}`}
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={onFieldChange}
                />
                {fieldErrors.email && (
                  <p className="contact__error">{fieldErrors.email}</p>
                )}
              </div>
            </div>
          </div>

          {/* PHONE */}
          <div className="contact__group">
            <div className="contact__row">
              <label className="contact__label">Teléfono</label>
              <div className="contact__field">
                <input
                  className={`contact__input ${fieldErrors.phone ? 'contact__input--error' : ''}`}
                  name="phone"
                  value={form.phone}
                  onChange={onFieldChange}
                />
                {fieldErrors.phone && (
                  <p className="contact__error">{fieldErrors.phone}</p>
                )}
              </div>
            </div>
          </div>

          {/* SUBJECT */}
          <div className="contact__group">
            <div className="contact__row">
              <label className="contact__label">Asunto</label>
              <div className="contact__field">
                <input
                  className={`contact__input ${fieldErrors.subject ? 'contact__input--error' : ''}`}
                  name="subject"
                  value={form.subject}
                  onChange={onFieldChange}
                />
                {fieldErrors.subject && (
                  <p className="contact__error">{fieldErrors.subject}</p>
                )}
              </div>
            </div>
          </div>

          {/* MESSAGE */}
          <div className="contact__group">
            <div className="contact__row-textarea">
              <label className="contact__label">Mensaje</label>
              <div className="contact__field">
                <textarea
                  className={`contact__textarea ${fieldErrors.message ? 'contact__textarea--error' : ''}`}
                  name="message"
                  value={form.message}
                  onChange={onFieldChange}
                />
                {fieldErrors.message && (
                  <p className="contact__error">{fieldErrors.message}</p>
                )}
              </div>
            </div>
          </div>

          <button type="submit" className="contact__submit">
            Enviar mensaje
          </button>
          {flashMessage && (
            <div className="contact__flash-message">
              <p>{flashMessage}</p>
            </div>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
